<template>
  <div>
    <table 
      v-if="mapConfig && mapConfig.length > 1"
      style="position: absolute;z-index: 7;width:100%;margin-top: 200px;">
      <tr>
        <td style="width: 40px;padding-left:10px;"  @click="handleChangeMap(-1)">
          <div style="background-color: #00000080;width:35px;border-radius:50%;padding:5px;">
            <v-icon color="white">mdi-arrow-u-right-bottom-bold</v-icon>
          </div>
        </td>
        <td style="width:auto;">
        </td>
        <td style="width: 40px;text-align:right;" @click="handleChangeMap(1)">
          <div style="background-color: #00000080;width:35px;border-radius:50%;padding:5px;">
            <v-icon color="white">mdi-arrow-u-left-bottom-bold</v-icon>
          </div>
        </td>
      </tr>
    </table>
    <!--table 
      v-if="mapConfig && mapConfig.length > 1"
      style="position: absolute;z-index: 7;width:100%;margin-top: 200px;">
      <tr>
        <td style="width: 50%;"  @click="handleChangeMap(-1)">
          prev
        </td>
        <td style="width: 50%;text-align:right;" @click="handleChangeMap(1)">
          next
        </td>
      </tr>
    </table-->
  <custom-canvas
    v-if="config"
    :key="config.id"
    :config="config"
    :locale="locale"
  />
  </div>
</template>
<script>
import apiDtouch from '@/services/apiDtouch'
import CustomCanvas from './CustomCanvas'
export default {
  components: {
    CustomCanvas,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    config: null,
    mapConfig: null,
  }),
  mounted () {
    this.handleGetData()
  },
  methods: {
    handleChangeMap (p) {
      this.config = null
      if (!p) {
        this.actualMap = 0
      } else if (p > 0) {
        if (this.actualMap + 1 === this.mapConfig.length) {
          this.actualMap = 0
        } else {
          this.actualMap++
        }
      } else if (p < 0) {
        if (this.actualMap - 1 < 0) {
          this.actualMap = this.mapConfig.length - 1
        } else {
          this.actualMap--
        }
      }
      const v = this.mapConfig[this.actualMap]
      if (!v) return
      const w = (document.getElementsByTagName('body')[0].clientWidth)
      this.oldWidth = w
      //const scale = w > v.Width ? 1 : w / v.Width
      const scale =  w / v.Width
      const width = v.Width * scale | 0
      const height = v.Height * scale | 0

      this.config = {
        id: v.ID,
        background: v.Image,
        scale,
        width,
        height,
        points: v.points,
        categories: v.categories,
      }
    },
    async handleGetData () {
      try {
        this.config = null
        if (!this.item.interactiveMapID) return
        const mapConfig = await new Promise((resolve, reject) => apiDtouch.getAll(`v2/public/interactive-maps/${this.item.interactiveMapID}/map-config`)
          .then(response => {
            resolve(response)
          }).catch (error => {
            reject(error)
          }))
        if (!mapConfig || mapConfig.length === 0) return

        for (let m of mapConfig) {
          m.categories = await new Promise((resolve, reject) => apiDtouch.getAll(`v2/public/interactive-maps/${m.ID}/categories`)
          .then(response => {
            if (response && response.length > 0) {
              response = response.map(item => {
                item.Name = JSON.parse(item.Name)
                return item
              })
              response.unshift({
                ID: null,
                Icon: 'mdi-folder',
                Name: { es: 'TODOS', en: 'ALL'}
              })
            }
            resolve(response)
          }).catch (error => {
            reject(error)
          }))


          m.points = await new Promise((resolve, reject) => apiDtouch.getAll(`v2/public/interactive-maps/${m.ID}/points`)
            .then(response => {
              resolve(response.map(item => {
                item.Title = JSON.parse(item.Title)
                item.Description = JSON.parse(item.Description)
                item.Info = item.Info ? JSON.parse(item.Info) : null
                return item
              }))
            }).catch (error => {
              reject(error)
            }))
        }

        this.mapConfig = mapConfig
        this.handleChangeMap(0)
        /*
        const categories = await new Promise((resolve, reject) => apiDtouch.getAll(`v2/public/interactive-maps/${this.item.interactiveMapID}/categories`)
          .then(response => {
            if (response && response.length > 0) {
              response = response.map(item => {
                item.Name = JSON.parse(item.Name)
                return item
              })
              response.unshift({
                ID: null,
                Icon: 'mdi-folder',
                Name: { es: 'TODOS', en: 'ALL'}
              })
            }
            resolve(response)
          }).catch (error => {
            reject(error)
          }))

        const map = await new Promise((resolve, reject) => apiDtouch.getItem(`v2/public/interactive-maps/${this.item.interactiveMapID}`)
          .then(response => {
            resolve(response)
          }).catch (error => {
            reject(error)
          }))
        const points = await new Promise((resolve, reject) => apiDtouch.getAll(`v2/public/interactive-maps/${this.item.interactiveMapID}/points`)
          .then(response => {
            resolve(response.map(item => {
              item.Title = JSON.parse(item.Title)
              item.Description = JSON.parse(item.Description)
              item.Info = item.Info ? JSON.parse(item.Info) : null
              return item
            }))
          }).catch (error => {
            reject(error)
          }))
        const w = (document.getElementsByTagName('body')[0].clientWidth)
        //const scale = w > v.Width ? 1 : w / v.Width
        const scale =  w / map.Width
        const width = map.Width * scale | 0
        const height = map.Height * scale | 0

        this.config = {
          background: map.Image,
          scale,
          width,
          height,
          points,
          categories,
        }*/
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

